import React, { useState } from 'react'

const TableData = ({ showIndex, columns, data, paginator, startRow, onSort,rowClick, rowSelector, customTableStyling }) => {
    const [rowSelect, setRowSelect] = useState(0);
    const selector = rowSelector ? rowSelector : 'id';

    const onRowClick = (item) => {
        if(item[selector] == rowSelect){
            setRowSelect(0)
            rowClick(item)
        }else{
            setRowSelect(item[selector]);
            rowClick(item)
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 mtable-container">
                <table className="table table-condensed" style={{ marginTop: 16, ...customTableStyling }}>
                    <thead>
                        <tr>
                            {showIndex && (<th style={{ width: 60 }}>No</th>)}
                            {columns.map((item, i) => {
                                return item.sortable
                                    ? <th key={'key-' + i} style={item.style || {}}>
                                        <div
                                            className="d-flex"
                                            style={{
                                                //justifyContent: 'space-between',
                                                justifyContent: '',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                            }}
                                            onClick={onSort(item.field)} >
                                            <span className="d-block mr-2 flex-1">{item.title}</span>
                                            {paginator.order == item.field &&
                                                <i
                                                    className={
                                                        paginator.direction == 'asc'
                                                            ? 'fa fa-arrow-down'
                                                            : 'fa fa-arrow-up'
                                                    }
                                                />}
                                        </div>
                                    </th>
                                    : <th key={'key-' + i} style={item.style || {}}>{item.title}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).map((item, i) => {
                            const newStyle = rowClick ? { cursor: "pointer" } : {};
                            const selectStyle = rowSelect == item[selector] ? { backgroundColor: '#ffe99b' } : {};
                            if (rowClick) {
                                return (
                                    <tr key={'key-' + i} style={{ ...selectStyle, ...newStyle }}>
                                        {showIndex && (<td>{i + startRow}</td>)}
                                        {columns.map((col, j) => {
                                            if (col.clickable) {
                                                return (
                                                    <td key={'key_col' + j} style={col.style ? col.style : {}} onClick={() => onRowClick(item)}>
                                                        {col.render ? col.render(item) : col.truncated? item[col.field].substring(0,100) + "..." : item[col.field]}
                                                    </td>
                                                );
                                            }else{
                                                return (
                                                    <td key={'key_col' + j} style={col.style ? { ...col.style } : {}}>
                                                      {col.render ? col.render(item) : col.truncated? item[col.field].substring(0,100) + "..." : item[col.field]}
                                                    </td>
                                                  );
                                            }
                                        })}
                                    </tr>
                                )
                            }else{
                                return (
                                    <tr key={'key-' + i} style={{ ...selectStyle }}>
                                      {showIndex && (<td>{i + startRow}</td>)}
                                      {columns.map((col, j) => {
                                        return (
                                          <td key={'key_col' + j} style={col.style ? { ...col.style } : {}} >
                                            {col.render ? col.render(item) : col.truncated? item[col.field].substring(0,100) + "..." : item[col.field]}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TableData